export * from './mediation.service';
export * from "./mediation.component";
export * from './mediation.model';


// WEBPACK FOOTER //
// ./src/app/mediation/index.ts